import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Dropdown from "../../components/Dropdown";
import {
  Container,
  Heading,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Stack,
  Text,
  Flex,
  Radio,
  RadioGroup,
  Select,
  Input,
  Button,
  useToast,
  Box,
} from "@chakra-ui/react";
import RadioCard from "../../components/candidate/newrequestform/RadioCard";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

const NewRequest = () => {
  // Parameters neccessary for making api requests
  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");
  const { id } = useParams();

  // User feedback cues
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  // Candidate name from getcandidateDets endpoint
  const [candidateName, setCandidateName] = useState("");
  const [gradeLevels, setGradeLevels] = useState([]);
  const [batteryOptions, setBatteryOptions] = useState([]);
  const [opDepartments, setOpDepartments] = useState([]);
  const [hrbps, setHrbps] = useState([]);
  const [requestors, setRequestors] = useState([]);

  // State for managing form form data
  const [formData, setFormData] = useState({
    candidateID: Number(id),
    // Remove gradeLevel and batteryID
    HbatteryID: null, // Keep HbatteryID for posting to addRequest11
    ddjobgradeID: "", // Add ddjobgradeID - the selected grade level ID
    requestCustodian: "", // Add requestCustodian to form data
    opDepartment: "",
    hrbp: null,
    requestor: null,
    costCenterNum: "",
    reqPurpose: "",
    posAppliedFor: "",
    currentPosition: "",
    empType: "",
    sendEmailYN: null,
  });

  const [errors, setErrors] = useState({
    sendEmailYN: "",
  });

  // GET request getCandidateDets for fetching candidate details
  const getCandidateDets = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getcandidateDets&huserID=${HuserID}&uuid=${UUID}&candidateID=${id}`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      const candidateDets = data[0].candidateDets[0];
      setCandidateName(candidateDets.fname + " " + candidateDets.sname);
    } catch (error) {
      toast({
        title: "Error fetching candidate details",
        description:
          "There was an error fetching the candidate. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // GET request getDDjobgrade for fetching grade levels
  const getDDjobgrade = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getDDjobgrade&huserID=${HuserID}&uuid=${UUID}&HclientID=11`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      setGradeLevels(data);
    } catch (error) {
      console.log(error);
      toast({
        title: "Error fetching grade levels",
        description: "There was an error loading grade levels. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // GET request getBatteryPerJobGrade for fetching battery options based on selected grade
  const getBatteryPerJobGrade = async (ddjobgradeID) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getBatteryPerJobGrade&huserID=${HuserID}&uuid=${UUID}&ddjobgradeID=${ddjobgradeID}`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      setBatteryOptions(data);
      
      // Store the HbatteryID from the response
      if (data && data.length > 0) {
        const hbatteryID = data[0].HbatteryID;

        
        // Store the HbatteryID in form data
        setFormData(prev => ({
          ...prev,
          HbatteryID: hbatteryID
        }));
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Error fetching battery options",
        description: "There was an error loading battery options. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // GET request getDepartmentPerClient
  const getDepartmentPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getDepartmentPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=11`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      setOpDepartments(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // GET request getHRBPPerClient
  const getHRBPPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getHRBPPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=11`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      setHrbps(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // GET request getRequestorsPerClient
  const getRequestorsPerClient = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getRequestorsPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=11`,
        {
          method: "GET",
        }
      );

      const data = await response.json();
      setRequestors(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // POST request addRequest11 for creating a new request:
  const postNewRequest = async () => {
    try {
      setLoading(true);
      return await fetch(
        `${API_BASE_URL}?method=addRequest11&huserID=${HuserID}&uuid=${UUID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          mode: "no-cors",
        }
      );
    } catch (error) {
      toast({
        title: "Error posting request details",
        description:
          "There was an error submitting your request. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      toast({
        title: "Request Submitted!",
        description: `Candidate ${candidateName} now has a request logged`,
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If grade level is changed, fetch battery options and store ddjobgradeID
    if (name === "gradeLevel") {
      setFormData({
        ...formData,
        ddjobgradeID: value, // Store the selected ddjobgradeID
      });
      // Clear battery options when grade level changes
      setBatteryOptions([]);
      // Fetch battery options for the selected grade
      if (value) {
        getBatteryPerJobGrade(value);
      }
      return;
    }

    // If battery is selected, store the HbatteryID in HbatteryID field only
    if (name === "batteryID") {
      setFormData({
        ...formData,
        HbatteryID: value, // Store HbatteryID in HbatteryID field for posting
        [name]: value,
      });
      return;
    }

    // Make sure current position / position applied for value matches request purpose
    if (e.target.value == "recruitment") {
      setFormData({
        ...formData,
        [name]: value,
        currentPosition: "",
      });
    } else if (e.target.value == "development") {
      setFormData({
        ...formData,
        [name]: value,
        posAppliedFor: "",
      });
    } else if (
      name === "costCenterNum" ||
      name === "empType" ||
      name === "posAppliedFor" ||
      name === "currentPosition" ||
      name === "requestCustodian" // Add requestCustodian to the list
    ) {
      setFormData({
        ...formData,
        [name]: value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: Number(value),
      });
    }
  };

  const handleRadioChange = (name, value) => {
    const boolValue = value === "true";

    // Update form data
    setFormData({
      ...formData,
      [name]: boolValue,
    });

    // Clear any previous error
    if (errors.sendEmailYN) {
      setErrors({
        ...errors,
        sendEmailYN: "",
      });
    }
  };

  // Validate sendEmailYN radio input
  const validateRadio = () => {
    const newErrors = {
      sendEmailYN: "",
    };

    let isValid = true;

    if (formData.sendEmailYN === null) {
      newErrors.sendEmailYN = "Please select an option";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate radio button input group before submission
    if (!validateRadio()) {
      return;
    }

    // Submit Form
    postNewRequest();

    setFormData({
      candidateID: Number(id),
      // Remove gradeLevel and batteryID
      HbatteryID: null, // Reset HbatteryID
      ddjobgradeID: "", // Reset ddjobgradeID
      requestCustodian: "", // Reset requestCustodian
      opDepartment: "",
      hrbp: null,
      requestor: null,
      costCenterNum: "",
      reqPurpose: "",
      posAppliedFor: "",
      currentPosition: "",
      empType: "",
      sendEmailYN: null,
    });
  };

  useEffect(() => {
    getCandidateDets();
    getDDjobgrade(); // Changed from getBatteriesPerClient()
    getDepartmentPerClient();
    getHRBPPerClient();
    getRequestorsPerClient();
  }, []);

  return (
    <Container minW="80vw" p={5}>
      <Heading className="text-xl font-bold" mb="12">
        New Request for {candidateName}
      </Heading>

      <form onSubmit={handleSubmit}>
        {/* Grade Level dropdown selection and Battery Options side by side */}
        <FormControl minH="100%" my={12} as="fieldset">
          <Flex direction="row" align="flex-start" gap={8}>
            {/* Grade Level dropdown - narrow */}
            <Box minW="200px">
              <FormLabel as="legend" fontWeight="bold" mt={2}>
                Select Grade Level
              </FormLabel>
              <Select
                name="gradeLevel"
                value={formData.ddjobgradeID} // Change from formData.gradeLevel to formData.ddjobgradeID
                onChange={handleChange}
                placeholder="Select a grade level"
                isRequired
                maxW="200px"
              >
                {gradeLevels.map((level) => (
                  <option key={level.ddjobgradeID} value={level.ddjobgradeID}>
                    Grade {level.gradeLevel}
                  </option>
                ))}
              </Select>
            </Box>

            {/* Battery Options - to the right */}
            {formData.ddjobgradeID && batteryOptions.length > 0 && (
              <Box flex="1">
                <FormLabel as="legend" fontWeight="bold" mt={2}>
                  Relevant Assessment Battery
                </FormLabel>
                <Flex
                  minH="100%"
                  direction={{
                    base: "column",
                    lg: "row",
                  }}
                  justify="flex-start"
                  spacing={4}
                  wrap="wrap"
                >
                  {batteryOptions.map((battery) => (
                    <RadioCard
                      isRequired
                      key={battery.allocRequestBatteryID}
                      value={battery.allocRequestBatteryID}
                      isChecked={formData.batteryID === battery.allocRequestBatteryID}
                      handleChange={handleChange}
                      name="batteryID"
                    >
                      <Flex direction="column" justify="space-between" align="left">
                        <Text fontWeight="bold" fontSize="md">
                          {battery.shortdescription}
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                          {battery.longdescription}
                        </Text>
                      </Flex>
                    </RadioCard>
                  ))}
                </Flex>
              </Box>
            )}
          </Flex>
        </FormControl>

        {/* Request Custodian dropdown */}
        <FormControl my={6}>
          <FormLabel fontWeight="bold">Request Custodian</FormLabel>
          <Select
            name="requestCustodian"
            value={formData.requestCustodian}
            onChange={handleChange}
            placeholder="Select request custodian"
            isRequired
            maxW="300px"
          >
            <option value="Dominion">Dominion</option>
            <option value="Transnet">Transnet</option>
          </Select>
        </FormControl>

        {/* Operation Department selection input */}
        <Dropdown
          margin="2"
          placeHolder="Select Operation Department"
          name="opDepartment"
          options={opDepartments}
          optionKey="HdepartmentID"
          optionDisplay="shortdescription"
          state={formData}
          handleChange={handleChange}
          required={true}
        />

        {/* HRBP selection input */}
        <Dropdown
          margin="4"
          placeHolder="Select HRBP"
          name="hrbp"
          options={hrbps}
          optionKey="HuserID"
          optionDisplay="fname"
          state={formData}
          handleChange={handleChange}
          optionDisplayAdd="sname"
          required={true}
        />

        {/* Requestor selection input */}
        <Dropdown
          margin="4"
          placeHolder="Select Requestor"
          name="requestor"
          options={requestors}
          optionKey="HuserID"
          optionDisplay="fname"
          state={formData}
          handleChange={handleChange}
          optionDisplayAdd="sname"
          required={true}
        />

        {/* Cost Center Number text input */}
        <FormLabel mt="8" fontWeight="bold">
          Cost Center Number
        </FormLabel>
        <Input
          name="costCenterNum"
          value={formData.costCenterNum}
          onChange={handleChange}
          type="text"
          isRequired
        />

        {/* Request Purpose radio button input */}
        <FormControl mt="8">
          <FormLabel fontWeight="bold">Request Purpose</FormLabel>
          <RadioGroup isRequired>
            <Stack direction="row">
              <Radio
                name="reqPurpose"
                value="recruitment"
                onChange={handleChange}
              >
                Recruitment
              </Radio>
              <Radio
                name="reqPurpose"
                value="development"
                onChange={handleChange}
              >
                Development
              </Radio>
            </Stack>
          </RadioGroup>
        </FormControl>

        {/* If Recruitment - Position Applied For text input */}
        {formData.reqPurpose === "recruitment" && (
          <FormControl my="4">
            <FormLabel fontWeight="bold">Position Applied For</FormLabel>
            <Input
              name="posAppliedFor"
              value={formData.posAppliedFor}
              onChange={handleChange}
              type="text"
              isRequired
            />
          </FormControl>
        )}

        {/* If Development - Current Position text input */}
        {formData.reqPurpose === "development" && (
          <FormControl my="4">
            <FormLabel fontWeight="bold">Current Position</FormLabel>
            <Input
              name="currentPosition"
              value={formData.currentPosition}
              onChange={handleChange}
              type="text"
              isRequired
            />
          </FormControl>
        )}

        {/* Employment Type selection input */}
        <Select
          name="empType"
          value={formData.empType}
          onChange={handleChange}
          placeholder="Employment Type"
          isRequired
          my="6"
        >
          <option>Permanent</option>
          <option>Fixed-Term</option>
          <option>Intern</option>
        </Select>

        {/* sendEmailYN checkbox input */}
        <FormControl isInvalid={!!errors.sendEmailYN} mt="12">
          <FormLabel fontWeight="bold">Email Candidate Notification</FormLabel>
          <RadioGroup
            isRequired
            name="sendEmailYN"
            value={formData.sendEmailYN === null ? "" : formData.sendEmailYN.toString()} // Convert boolean to string
            onChange={(value) => handleRadioChange("sendEmailYN", value)}
          >
            <Radio value="true" mr="8">
              Yes
            </Radio>
            <Radio value="false">No</Radio>
          </RadioGroup>
          <FormErrorMessage color="secondary2">
            {errors.sendEmailYN}
          </FormErrorMessage>
        </FormControl>

        {/* Form submit button */}
        <Button type="submit" my="12">
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default NewRequest;
